/**
 * 跳转路由
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/components/index'
import login from '@/components/user/login'
import forgotPassword from '@/components/user/forgotPassword'
import accountAssociated from '@/components/user/accountAssociated'
import personalCenter from '@/components/user/personalCenter'
import register from '@/components/user/register'
import articleEditor from '@/components/article/articleEditor'
import article from '@/components/article/articleList'
import articleQuery from '@/components/article/articleQuery'
import articleDetail from '@/components/article/articleDetail'
import newsList from '@/components/news/newList'
import serviceMain from '@/components/service/serviceMain'
import company from '@/components/about/company'
import contactUs from '@/components/about/contactUs'
import join from '@/components/about/join'
import storeSearch from '@/components/install/storeSearch'
import carSearch from '@/components/install/carSearch'
import scanInstall from '@/components/install/scanInstall'
import productDetail from '@/components/product/productDetail'
import shopCar from '@/components/shoppingCar/shopCar'
import settlement from '@/components/shoppingCar/settlement'
import payment from '@/components/shoppingCar/payment'
import orderList from '@/components/shoppingCar/orderList'
import testQr from '@/components/test/testQrcode'
import userHome from '@/components/user/userHome'
import anotherHome from '@/components/user/anotherHome'
// 临时新增
import internal from '@/components/common/internal'
import store from './store'

Vue.use(VueRouter)

const routes = [
  {path: '/', name: 'index', component: index, meta: {}},
  {path: '/login', name: 'login', component: login, meta: {notFoot: true}},
  {path: '/personalCenter', name: 'personalCenter', component: personalCenter, meta: {}},
  {path: '/test/qr', name: 'testQr', component: testQr, meta: {notFoot: true}},
  {path: '/user', name: 'userHome', component: userHome, meta: {needAuth: true}},
  {path: '/other', name: 'anotherHome', component: anotherHome},
  {path: '/product/detail', name: 'productDetail', component: productDetail, meta: {}},
  {path: '/install/storeSearch', name: 'storeSearch', component: storeSearch, meta: {}},
  {path: '/install/carSearch', name: 'carSearch', component: carSearch, meta: {}},
  {path: '/install/scanInstall', name: 'scanInstall', component: scanInstall, meta: {}},
  {path: '/about', name: 'company', component: company, meta: {}},
  {path: '/about/contact', name: 'contactUs', component: contactUs, meta: {}},
  {path: '/about/join', name: 'join', component: join, meta: {}},
  {path: '/service', name: 'serviceMain', component: serviceMain, meta: {}},
  {path: '/news', name: 'newsList', component: newsList, meta: {}},
  {path: '/article', name: 'article', component: article, meta: {}},
  {path: '/article/editor', name: 'articleEditor', component: articleEditor, meta: {needAuth: true}},
  {path: '/article/detail', name: 'articleDetail', component: articleDetail, meta: {keepAlive: true}},
  {path: '/article/query', name: 'articleQuery', component: articleQuery, meta: {keepAlive: true}},
  {path: '/shoppingCar/shopCar', name: 'shopCar', component: shopCar, meta: {}},
  {path: '/shoppingCar/settlement', name: 'settlement', component: settlement, meta: {}},
  {path: '/shoppingCar/payment', name: 'payment', component: payment, meta: {}},
  {path: '/shoppingCar/orderList', name: 'orderList', component: orderList, meta: {}},
  {path: '/register', name: 'register', component: register, meta: {notFoot: true, title: '注册'}},
  {path: '/forgotPassword', name: 'forgotPassword', component: forgotPassword, meta: {notFoot: true}},
  {path: '/accountAssociated', name: 'accountAssociated', component: accountAssociated, meta: {notFoot: true}},
  // 临时新增
  {path: '/internal', name: 'internal', component: internal, meta: {notFoot: true}}
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.afterEach(function (transition) {
  document.title = transition.meta.title || '车灯师官网'
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.needAuth)) {
    if (store.state.token) {
      next()
    } else {
      next({name: 'login', params: {redirect: to.fullPath, tips: '此功能需要登录后才能操作'}})
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/common/js/router.js